import { render } from "./ReportGeofenceSummaryKm.vue?vue&type=template&id=a755ca56"
import script from "./ReportGeofenceSummaryKm.vue?vue&type=script&lang=js"
export * from "./ReportGeofenceSummaryKm.vue?vue&type=script&lang=js"

import "./ReportGeofenceSummaryKm.vue?vue&type=style&index=0&id=a755ca56&lang=css"
script.render = render

export default script